export default {
  nfcUID: 'NFC UID',
  productCode: 'Product Code',
  productName: 'Product Name',
  size: 'Size',
  upc: 'UPC',
  requiredChannel: 'Required Channel',
  tagTypeDesc: 'Actual Tag Type Desc',
  plant: 'Plant',
  status: 'Status',
  tagStatus: 'Tag Status',
  workstation: 'Workstation',
  orderNumber: 'Order Number',
  taggingDate: 'Tagging Date',
  sendDate: 'Send Date',
  sendStatus: 'Send Status',
  action: 'Action',
  operation: 'Operation',
  operator: 'Operator',
  apiDate: 'API Date',
  dateLimt: 'Over the query date limit',
  system: 'System',
  nfcUidReport: 'NFC UID Report',
  operationDate: 'Operation Date',
  unbind: 'Unbind',
  unbindMessage: 'Do you confirm to unbind?',
  unbindError1: 'Be disabled nfc tag can not unbind.',
  unbindError2: 'Unbind nfc transfer ant interface fail.',
  disableError: 'Disable transfer ant interface fail.'
}
